export { useFastshiftAnalyticsData } from "./use-fastshift-analytics-data";
